import React, { SetStateAction, useEffect, useState } from 'react'

//STYLES

//APP
import { ItensPerUserLogged } from '../../../../../../services/login/permissaoUsuarioLoado'
import { removerAcentos } from '../../../../../../utils'

//COMPONENTS

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faEdit, faPlus } from '@fortawesome/free-solid-svg-icons'
import { Empty, Tag } from 'antd'
import { Inline } from '../../../../../../Components/CustomUi/inline'
import Input from '../../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../../Components/ButtonCustom'
import { HeaderTable } from '../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../../Components/CustomUi/deleteButton'
import Carregando from '../../../../../../Components/CustomUi/loading'

//PROPS
interface Props {
  loading: boolean
  setPagination: React.Dispatch<React.SetStateAction<number>>
  page: number
  setPage: React.Dispatch<React.SetStateAction<number>>
  total: number
  list_biologicos: any[]
  permissions: ItensPerUserLogged
  abrir: Function
  editarCadastro: Function
  duplicar: Function
  deletar: Function
  buscarTabela: string
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  filtroAtivado?: boolean
  setFiltroAtivado?: React.Dispatch<React.SetStateAction<boolean>>
  totalRef: number
}

export const TabelaBiologicos: React.FC<Props> = ({
  loading,
  page,
  setPage,
  setPagination,
  total,
  list_biologicos,
  permissions,
  abrir,
  editarCadastro,
  duplicar,
  deletar,
  buscarTabela,
  setBuscarTabela,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  filtroAtivado,
  setFiltroAtivado,
  totalRef,
}) => {
  function buscarBiologicos(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))
      return nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) || !buscar_nome
    }
  }

  return (
    <div style={{ height: 'calc(100vh - 180px)' }}>
      <Inline alignItems='center'>
        <Input placeholder='Buscar biológicos por nome, origem ou espécie' value={buscarTabela} onChange={setBuscarTabela} />
        <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
          Novo
        </ButtonCustom>
      </Inline>
      <HeaderTable
        itens={[
          { valor: 'Nome', width: 'calc(100% - 965.5px)' },
          { valor: 'Origem', width: '150px' },
          { valor: 'Tipo biológicos', width: '300px' },
          { valor: 'Espécies', width: '300px' },
          { valor: 'Ações', width: '210px' },
        ]}
      />

      <BodyTable
        paginate={totalRef}
        paginateFilter={
          filtroAtivado ? (list_biologicos ?? []).filter(buscarBiologicos(buscarTabela)).length : 0
        }
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: 'calc(100vh - 280px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(list_biologicos ?? [])
            // .filter(buscarBiologicos(buscarTabela))
            .map(({ cod, nome, parametros_bioinsumo, finalidades, biocomposicao }, index) => {
              return (
                <RowTable
                  style={{ marginTop: index === 0 ? '10px' : '0px', height: 'auto' }}
                  key={cod}
                  onDoubleClick={() => { }}
                >
                  <RowItem fontSize={13} width={'calc(100% - 960px)'}>
                    {nome}
                  </RowItem>

                  <RowItem fontSize={13} width={'150px'}>
                    {parametros_bioinsumo[0]?.origem_nome}
                  </RowItem>

                  <RowItem
                    fontSize={13}
                    width={'300px'}
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'flex-start',
                      alignContent: 'center',
                    }}
                  >
                    {finalidades?.map((tag) => {
                      return (
                        <Tag
                          color='green'
                          key={tag.cod}
                          style={{ margin: 5, fontSize: '10px', whiteSpace: 'normal' }}
                        >
                          {tag.finalidade_nome.toUpperCase()}
                        </Tag>
                      )
                    })}
                  </RowItem>
                  <RowItem
                    fontSize={13}
                    width={'300px'}
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      justifyContent: 'flex-start',
                      alignContent: 'center',
                    }}
                  >
                    {biocomposicao?.length <= 0 ? (
                      <Tag
                        color='blue'
                        style={{ margin: 5, fontSize: '10px', whiteSpace: 'normal' }}
                      >
                        COMPLEXO DE MICRORGANISMOS
                      </Tag>
                    ) : (
                      biocomposicao?.map((tag) => {
                        return (
                          <Tag
                            color='blue'
                            key={tag.cod}
                            style={{ margin: 5, fontSize: '10px', whiteSpace: 'normal' }}
                          >
                            {tag.microrganismo_nome.toUpperCase()}
                          </Tag>
                        )
                      })
                    )}
                  </RowItem>

                  <RowItem width={'210px'} gap={10}>
                    <DeleteButton
                      open={confirmar_exclusao && id_item_atual === cod}
                      trigger={setConfirmar_exclusao}
                      onTrigger={() => {
                        setId_item_atual(cod)
                        setNome_item_atual(nome)
                      }}
                      loading={fake_loading}
                      message={`o item ${nome} será excluido!`}
                      deleteds={[nome]}
                      onDelete={() => {
                        deletar(cod)
                      }}
                      disabled={fake_loading}
                    />
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faCopy} />}
                      onClick={() => duplicar(cod)}
                      type='secondary'
                    />
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faEdit} />}
                      onClick={() => editarCadastro(cod)}
                       disabled={permissions?.acesso === 1}
                    >
                      Editar
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={list_biologicos?.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando biológicos...'
            justifyContent='center'
            height={300}
            size='default'
          />
        </Render>
      </BodyTable>
    </div>
  )
}
